import React from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Grid,
} from "@mui/material";

const AdminEmail = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Email Management
      </Typography>
      
      <Paper sx={{ p: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Email Template"
              multiline
              rows={10}
              placeholder="Enter your email template here..."
            />
          </Grid>
          <Grid item xs={12}>
            <Button variant="contained" color="primary">
              Save Template
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default AdminEmail;
